// extracted by css-extract-rspack-plugin
export default {"dropdown":"LSRiz","tooltip":"VGIUt","target":"K6_k6"};